"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TooltipWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  outline: 0;\n  color: #1890ff;\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  &:hover {\n    color: #40a9ff;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.18s ease-out 0.18s;\n  text-indent: 0;\n  font-size: 12px;\n  background: rgba(0, 0, 0, 0.75);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  text-decoration: none;\n  text-align: left;\n  word-wrap: break-word;\n  border-radius: 2px;\n  color: #fff;\n  padding: 0.5em 1em;\n  margin-bottom: 10px;\n  position: absolute;\n  white-space: nowrap;\n  z-index: 10;\n  bottom: 100%;\n  left: 50%;\n  transform: translate(-50%, 4px);\n  transform-origin: top;\n  &:before {\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    border-top-color: rgba(0, 0, 0, 0.75);\n    pointer-events: none;\n    transition: all 0.18s ease-out 0.18s;\n    content: '';\n    position: absolute;\n    z-index: 10;\n    bottom: -10px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    transform-origin: top;\n  }\n  div {\n    width: 156px;\n    white-space: normal;\n    &,\n    * {\n      margin: 0;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipWrapper = _styledComponents.default.div(_templateObject());

exports.TooltipWrapper = TooltipWrapper;

var Link = _styledComponents.default.a(_templateObject2());

var _default = function _default(props) {
  var isBigfish = props.isBigfish,
      message = props.message;
  var helpDocUrl = isBigfish ? 'https://bigfish.antfin-inc.com/doc/bigfish-ui' : 'https://umijs.org/guide/umi-ui.html';
  var intro = message.intro,
      tooltip = message.tooltip,
      helpDoc = message.helpDoc;
  var introText = (0, _utils.render)(intro, {
    framework: isBigfish ? 'Bigfish' : 'Umi'
  });
  return /*#__PURE__*/_react.default.createElement(TooltipWrapper, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, introText, /*#__PURE__*/_react.default.createElement(Link, {
    target: "_blank",
    rel: "noopener noreferrer",
    href: helpDocUrl
  }, helpDoc), tooltip)));
};

exports.default = _default;